/* tslint:disable */
/* eslint-disable */
/**
 * BackendFramework
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface UserEditStepWrapper
 */
export interface UserEditStepWrapper {
  /**
   *
   * @type {string}
   * @memberof UserEditStepWrapper
   */
  editGuid: string;
  /**
   *
   * @type {string}
   * @memberof UserEditStepWrapper
   */
  stepString: string;
  /**
   *
   * @type {number}
   * @memberof UserEditStepWrapper
   */
  stepIndex?: number | null;
}
